<template>
  <li v-if="$checkPermission(permission)" :class="[
    'nav-item',
    {
      'menu-is-opening is-open': selected,
    }]">

    <router-link :to="path" class="nav-link d-flex align-items-center children-level" :class="{
      'router-link-exact-active router-link-active is-active': selected,
      'disabled-link': selected,

    }">
      <i v-if="iconClass" :class="`nav-icon ${iconClass} pl-1`" style="margin-right: 0.35rem;"></i>

      <component :is="getIconComponent" :icon-class="getIconClass" v-if="iconComponent" class="nav-icon" />
      <p class="mb-0 d-flex align-items-center">
        {{ title }}
        <i v-if="hasChildren" class="fas fa-angle-right right ml-auto" :class="{ 'rotate-icon': selected }"></i>
      </p>
    </router-link>

    <ul class="nav nav-treeview" :style="{ display: selected ? 'block' : 'none' }">
      <MenuItem v-for="(item, index) in children" :key="item.path || index.toString()" v-bind="getChildProps(item)"
        @handle-click-menu="handleChildClick" :children-level="childrenLevel + 1" />
    </ul>

  </li>
</template>

<script>
import IconDash from '../Icons/IconDash.vue';
import IconGatepass from '../Icons/IconGatepass.vue';
import IconInventory from '../Icons/IconInventory.vue';
import IconLead from '../Icons/IconLead.vue';
import IconPayment from '../Icons/IconPayment.vue';
import IconQuotation from '../Icons/IconQuotation.vue';
import IconWallet from '../Icons/IconWallet.vue';

const ICON_COMPONENTS = {
  dashIcon: IconDash,
  leadsIcon: IconLead,
  jobcardIcon: IconWallet,
  quotationIcon: IconQuotation,
  IconPayment: IconPayment,
  inventory: IconInventory,
  gatepassIcon: IconGatepass
};

export default {
  name: 'MenuItem',
  components: {
    MenuItem: () => import('./MenuItem.vue'),
    ...ICON_COMPONENTS
  },

  props: {
    childrenLevel: {
      type: Number,
      default: 0
    },
    isOpen: {
      type: String,
      default: ''
    },
    isCollapsing: {
      type: Boolean,
      default: false
    },
    path: {
      type: String,
      default: '/'
    },
    permission: {
      type: [String, Array],
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    iconClass: {
      type: String,
      default: ''
    },
    children: {
      type: Array,
      default: () => []
    },
    iconComponent: {
      type: String,
      default: ''
    },
    isActived: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    hasChildren() {
      return this.children?.length > 0;
    },
    getIconComponent() {
      return ICON_COMPONENTS[this.iconComponent] || null;
    },
    getIconClass() {
      return this.iconComponent === 'gatepassIcon' ? 'pr-0' : 'pr-1';
    }
  },

  methods: {
    handleChildClick(title) {
      this.$emit('handle-click-menu', title);
    },

    getChildProps(item) {
      return {
        title: item.title,
        'icon-class': item.iconClass,
        children: item.children,
        path: item.path,
        'is-open': this.isOpen,
        'is-collapsing': this.isCollapsing,
        'is-actived': item.isActived,
        'icon-component': item.iconComponent,
        permission: item.permission
      };
    },

  },

};
</script>
<style scoped>
.children-level {
  font-family: 'Inter';
  font-weight: 400;
}

.children-level.nav-treeview {
  padding-left: v-bind(childrenLevel+10)+'px';
}

.nav-item .children-level p i {
  position: absolute;
  right: 1rem;
  top: 0rem;
  bottom: 0;
  margin: auto;
  height: fit-content;
}

.nav-item:not(:last-child) .children-level p {
  padding-top: 0.25rem;
}

.is-active.children-level,
.router-link-active.children-level {
  color: #2e7efe !important;
  background: #0a68fe0a !important;
  background-color: #f9f9f9f5 !important;

}
</style>